module.exports = __webpack_public_path__ + "static/AzoSans-Regular-076316ea6b0db9122630731079fe0c8a.woff2";